import Industries from "@/components/sections/Industries";
import PageHeader from "@/components/PageHeader";
import SEO from "@/components/SEO";
import { SEO_MAP } from "@/lib/seoMap";

export default function IndustriesPage() {
  return (
    <main data-testid="industries-page">
      <SEO {...SEO_MAP.industries} />
      <PageHeader overline="Industries" title={<>Deep experience,<br /><em className="italic">deliberately chosen</em>.</>}
                  lead="Fourteen sectors where we've built patterns, playbooks and portfolios." />

      <section className="max-w-[1400px] mx-auto px-6 lg:px-10 pb-6 -mt-6">
        <div className="grid grid-cols-12 gap-6">
          <div className="col-span-12 md:col-span-9">
            <p className="text-[15px] text-[color:var(--text-muted)] leading-relaxed">
              We work across fourteen sectors — healthcare, recruitment, construction, hospitality,
              retail, education, finance, legal, real estate, manufacturing, logistics, cleaning
              services, professional services and government. Each of these industries carries its own
              regulatory context, buyer expectations, integration landscape and unit-economics reality —
              and we've built enough in each to arrive with patterns rather than assumptions. That means
              a shorter discovery phase for you, fewer wrong turns during design, and delivery informed
              by what we've already seen work. Whether you're modernising a legacy corporate site,
              launching a specialised e-commerce experience, automating operations, or building an
              internal system that becomes an operational advantage, we're comfortable moving from
              first-principles conversation to shipped software inside a quarter.
            </p>
          </div>
        </div>
      </section>

      <Industries />
    </main>
  );
}
